import React, { useRef, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const Step1 = ({ control, errors, onNext }) => {
  const phoneInputRef = useRef(null);
  useEffect(() => {
    if (
      errors.phone &&
      phoneInputRef.current &&
      phoneInputRef.current.focus
    ) {
      phoneInputRef.current.focus();
    }
  }, [errors]);

  return (
    <div className='data-container'>
      <h2>Primero verifiquemos tu teléfono</h2>
      <Controller
        name='phone'
        control={control}
        defaultValue=''
        rules={{ required: 'El teléfono es requerido' }}
        render={({ field, fieldState: { error } }) => (
          <div className='form-group phone-input-container'>
            <PhoneInput
              ref={phoneInputRef}
              country={'co'}
              enableSearch={true}
              countryCodeEditable={false}
              placeholder='Teléfono'
              className={error ? 'input-error' : ''}
              {...field}
              onChange={(phone) => field.onChange(phone)}
              inputProps={{
                name: 'phone',
                required: true,
                autoFocus: true,
              }}
            />
            {error && <p className='error-msg'>{error.message}</p>}
          </div>
        )}
      />
      <div className='controls'>
        <button
          type='button'
          className='btn primary'
          onClick={onNext}>
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default Step1;
